import type { FC, PropsWithChildren } from "react";
import Divider from "../general/Divider";
import * as s from "./Footer.module.scss";

const Footer: FC<PropsWithChildren> = ({ children }) => (
	<footer className={s.container}>
		<Divider variant="horizontal" />
		{children}
	</footer>
);
export default Footer;
